/**
 * Categorias de «Itens disponíveis» — ordem e nomes alinhados com public/images/icons/.
 * Pastas extra no disco são mapeadas para a categoria de exibição (ex. Médico → Medicamentos).
 */

/** Ordem das categorias no simulador (sem Veículos). */
export const SIMULATOR_CATEGORY_ORDER = [
    "Armadilhas",
    "Armas",
    "Comida",
    "Componentes",
    "Construção",
    "Elétrica",
    "Ferramentas",
    "Itens",
    "Medicamentos",
    "Munição",
    "Outros",
    "Recursos",
    "Roupas",
];

/** Pastas que não entram no pool do simulador. */
export const SIMULATOR_EXCLUDED_FOLDERS = new Set(["Veículos"]);

/**
 * Pasta no disco (manifest) → categoria mostrada no simulador.
 * @type {Record<string, string>}
 */
export const ICON_FOLDER_TO_DISPLAY_CATEGORY = {
    Médico: "Medicamentos",
    Elétrico: "Elétrica",
    Diversão: "Outros",
};

/**
 * @param {string} folderName — nome da pasta em public/images/icons/
 * @returns {string | null} null = excluir do simulador
 */
export function mapFolderToDisplayCategory(folderName) {
    if (SIMULATOR_EXCLUDED_FOLDERS.has(folderName)) return null;
    return ICON_FOLDER_TO_DISPLAY_CATEGORY[folderName] ?? folderName;
}

/** Chaves de categoria válidas no pool (ordenadas). */
export function getSimulatorCategoryKeys() {
    return [...SIMULATOR_CATEGORY_ORDER];
}
